import React, { useEffect, useState } from 'react';
import { useSearch } from '../../SearchContext';
import Pagination from '~/components/Pagination';
import { ContainerLimit, PaginationFooter } from '../../styles';
import { InputSelect } from '~/components/NovosInputs';

const Paginated: React.FC = () => {
  const {
    linkMaterial,
    limit,
    rowsCount,
    setIsUpdateLimit,
    changeLimit,
    returnCount,
    handleLoadNewPage,
    page,
    codTela,
    RefetchView,
    control,
    register,
    setValue,
  } = useSearch();

  const [isBottom, setIsBottom] = useState(false);

  useEffect(() => {
    setValue('limit-pagination', { value: 10, label: '10' });

    const handleScroll = () => {
      const scrolledToBottom =
        window.innerHeight + window.scrollY >= document.body.offsetHeight;
      setIsBottom(scrolledToBottom);
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  return (
    <PaginationFooter isBottom={isBottom}>
      <div style={{ minWidth: '100px' }}>
        {linkMaterial && (
          <div className="containerMaterial">
            <a
              href={linkMaterial}
              target="_blank"
              className="linkMaterial"
              rel="noreferrer"
            >
              Precisa de ajuda?
            </a>
          </div>
        )}
      </div>
      <ContainerLimit>
        <label htmlFor="limit-pagination">Registros por página</label>
        <InputSelect
          label=""
          id="limit-pagination"
          className="limit-pagination"
          options={[
            { value: 10, label: '10' },
            { value: 20, label: '20' },
            { value: 30, label: '30' },
          ]}
          name="limit-pagination"
          register={register}
          control={control}
          isError={false}
          changeSelected={async (option: { value: number; label: string }) => {
            const { value } = option;
            setIsUpdateLimit(true);
            await changeLimit(value);
            setValue('limit-pagination', option);
          }}
        />
      </ContainerLimit>
      <div
        style={{
          display: 'flex',
          flexWrap: 'wrap',
          alignItems: 'center',
          gap: '12px',
        }}
      >
        {rowsCount > 0 && rowsCount === 1 && (
          <p className="my-2">{rowsCount} registro encontrado.</p>
        )}
        {rowsCount > 1 && <p className="my-2">{returnCount()}</p>}
        {rowsCount <= 0 && <p className="my-2">0 registros encontrados.</p>}

        <Pagination
          onPageChange={handleLoadNewPage}
          currentPage={page}
          tela={codTela}
          rowsCount={rowsCount}
          limit={limit}
          updatePage={RefetchView}
        />
      </div>
    </PaginationFooter>
  );
};

export default Paginated;
